import { Row, Col, Typography, Button } from "antd";
import HeroPageImage from "../../assets/images/hero-page-mobile.webp";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./index.less";

const { Title, Paragraph } = Typography;

const HomePageHeroSection = () => {
  const { t } = useTranslation();
  return (
    <Row className="hero_main">
      <Title className="hidden">{t("Twizz")}</Title>
      <Title className="hidden">{t("want-to-monetize-your-content-text")}</Title>
      <Title level={2} className="hidden">
        {t("no-matter-how-you-want-to-convert-text")}
      </Title>
      <Row className="hero_section" align="top">
        <Col className="hero_content">
          <Title className="hero_title">{t("the-exclusive-experience")}</Title>
          <div className="hero_description">
            <Paragraph className="para4">{t("want-to-monetize-your-content-text")}</Paragraph>
            <Paragraph className="para4">{t("no-matter-how-you-want-to-convert-text")}</Paragraph>

            <Paragraph className="para4">{t("sign-up-for-free-in-one-click")}</Paragraph>
          </div>
          <div className="hero_buttons">
            <Link to="/auth/signUp?currentTab=creator" className="button_links">
              <Button className="hero_button2 primary_button">{t("auth-tab-creator")}</Button>
            </Link>
            <Link to="/auth/signUp" className="button_links">
              <Button className="hero_button2 secondary_button">Fans</Button>
            </Link>
          </div>
          <Link to="/auth/signIn">
            <Button className="start_up_button">{t("home-nav-login-title")}</Button>
          </Link>
        </Col>
        <Col className="hero_image_container">
          <img src={HeroPageImage} alt="Hand" className="hero_image" />
        </Col>
      </Row>
    </Row>
  );
};

export default HomePageHeroSection;
